export const environment = {
  	production: false,
	environment: 'staging',
	baseUrl: 'https://api.staging.atlasv2.idcid.fr/',
	allowedDomains: ['api.staging.atlasv2.idcid.fr'],
	ckeditorLicenceKey: "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NzI3NTUxOTksImp0aSI6ImEwMzYxZWFmLTM0ZDYtNDRlMC1iOWQyLTA5YzUyOWNjM2E5YiIsImxpY2Vuc2VkSG9zdHMiOlsiMTI3LjAuMC4xIiwibG9jYWxob3N0IiwiMTkyLjE2OC4qLioiLCIxMC4qLiouKiIsIjE3Mi4qLiouKiIsIioudGVzdCIsIioubG9jYWxob3N0IiwiKi5sb2NhbCJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sImxpY2Vuc2VUeXBlIjoiZGV2ZWxvcG1lbnQiLCJmZWF0dXJlcyI6WyJEUlVQIl0sInZjIjoiNzA3Mjk4YjIifQ.MRYh3ydyGJRqYaEYlNGFz9drgOnsP55lWcpuvk64_UPA02CC1ALJ9TrHAydoSFpSReUw0iCEkqcWKZcxv_T2DQ",
  	authorization: null,
	typesense: {
		host: 'ts.atlasv2.hubstack.fr',
		apikey: 'ABMwMSiLFKHHyS9GoGdYBW5B',
		collection: 'bis_staging'
	},
	msalConfig : {
		auth: {
			clientId: '8a4a2817-7e1d-4dbe-8c87-76446873ca7b',
			authority: 'https://login.microsoftonline.com/7567b5b5-54ac-4817-b05e-9bde6bd26411/common',
		},
		api: {
			scopes: ['user.read', 'CustomSecAttributeAssignment.Read.All'],
			uri: 'https://graph.microsoft.com/v1.0/me'
		}
	}
};
// https://login.microsoftonline.com/7567b5b5-54ac-4817-b05e-9bde6bd26411/oauth2/v2.0/authorize